// extracted by mini-css-extract-plugin
export default {"timeInput":"AppointmentFormTimeSection_timeInput__sgmr0"};